'use strict';
(function () {
	angular.module('dat.shared-components.location')
		.directive('datLocationInput', datLocationInput);

	datLocationInput.$inject = ['$rootScope', '$parse', '$document', '$timeout', 'LocationService', 'searchValidator', '$log'];
	var $rootScope, $parse, $document, $timeout, locationService, searchValidator, $log;

	function datLocationInput(_$rootScope_, _$parse_, _$document_, _$timeout_, _locationService_, _searchValidator_, _$log_) {
		$rootScope = _$rootScope_; $parse = _$parse_; $document = _$document_; $timeout = _$timeout_; locationService = _locationService_; searchValidator = _searchValidator_; $log = _$log_;

		return {
			template:   '<label class="search-input-container validated-input" name="{{fieldName}}">' +
                                '<input id="{{fieldName}}" name="{{fieldName}}"  tabindex="{{tabIndex}}" type="text" ng-model="ngModel[fieldName]" class="search-input editContent" placeholder="{{placeHolder}}" maxlength="200" ' +
                                        'ng-disabled="disableLocation.disable" ui-event="{focus : \'inputFocusHandler()\', keyup : \'clearValidation($event)\'  }"' +
                                '/>' +
                                '<div dat-input-error="{{ngModel[fieldName+\'Validation\'].invalid}}" dat-input-error-for="input#{{fieldName}}" placement="top" hide-on-blur="true" class="tooltip">{{ngModel[fieldName+\'Validation\'].message}}</div>' +
                            '</label>',
			replace:true,
			restrict: 'E',
			scope: {
				ngModel: '=',
				fieldName:'@',
				placeHolder: '@',
				tabIndex:'@',
				tryApplyStickyValue:'&', // TODO - keep this callback for now. Later decide whether to incorporate the functionality implemented by the callback inside this directive.
				getValidateLocationPromise: '&',
				allowEmptyLocation: '@',
				allowAreaLocationType: '@',
				disableLocation: '='
			},
			link: linkFunction
		};
	}

	var validateLocationPromise;

	function linkFunction(scope, element) {
		var isChanged = false;

		// Set default behavior to NOT allow empty locations or area location types
		var allowEmptyLocation = (scope.allowEmptyLocation === 'true');
		var allowAreaLocationType = (scope.allowAreaLocationType === 'true');
		validateLocationPromise = undefined;
		var inputElement = element.find('input');

		scope.inputFocusHandler = function () {
			if (scope.tryApplyStickyValue) {
				try {
					inputElement.autocomplete('disable');
					var wasApplied = scope.tryApplyStickyValue({ fieldName: scope.fieldName });
					if (wasApplied) {
						$timeout(function () {
							element.find('input').select();
						}, 75);
					}
				}
				finally {
					$timeout(function () {
						inputElement.autocomplete('enable');
					}, 50);
				}
			}
		};

		var updateModel = function(value, handle) {
			scope.$apply(function() {
				scope.ngModel[scope.fieldName] = value;
				scope.ngModel[scope.fieldName + 'Handle'] = handle ? handle : null;
			});
		};

		var handleItemChanged = function(ui) {
			debugVerbose('handleItemChanged');
			if (!inputElement.hasClass('ng-dirty')) {
				return;
			}
			if(ui.item) {
				// This case is when a choice was selected from the piclist
				debugVerbose('Calling updateModel with values: ' + ui.item.value + ', ' + ui.item.handle);
				updateModel(ui.item.value, ui.item.handle);
			}
			else {
				// This case is when the input was changed by not picking something from the piclist
				debugVerbose('Calling updateModel with value: ' + inputElement.val());
				updateModel(inputElement.val());
			}

			if (scope.getValidateLocationPromise && !ui.item) {
				handleLocationChange(scope.fieldName); // need to validate the value because it was not chosen from the piclist
			}
			isChanged = true;
		};

		function handleLocationChange(fieldName) {
			validateLocationPromise = scope.getValidateLocationPromise();
			if (!validateLocationPromise) return;
			validateLocation(fieldName);
		}

		function validateLocation(fieldName) {
			var criteria = scope.ngModel;
			criteria[fieldName] = _.str.ltrim(criteria[fieldName]);
			verifyLocation(criteria, fieldName);
		}

		function verifyLocation(searchCriteria, locationType) {
			// Note: In the case when the searchCriteria[fieldName + "Handle"] is defined the call to searchValidator.validateField will not result
			// in a call to the API api/location/resolve
			$timeout(function() {
				searchValidator.validateField(searchCriteria, locationType, allowEmptyLocation, allowAreaLocationType).then(function(locationValid) {
					validateLocationPromise.resolve(locationValid);
					updateFormFieldsPlaceholderText(locationValid);
				}, function () {
					validateLocationPromise.reject();
					updateFormFieldsPlaceholderText(false);
				});
			}, 200);
		}

		function updateFormFieldsPlaceholderText(locationValid) {
			scope.placeHolder = locationValid ? scope.placeHolder : '';
		}

		scope.clearValidation = function(evt) {
			var searchCriteria = scope.ngModel;
			var field = scope.fieldName;
			if (evt.keyCode === 9 || evt.keyCode === 16 || evt.keyCode === 13)
				return;

			debugVerbose('clearValidation. keyCode = ' + evt.keyCode);

			if (field === 'origin') {
				searchCriteria.originHandle = null;
				if(scope.allowAreaLocationType === 'true' && angular.isDefined(searchCriteria.originIsArea)) {
					searchCriteria.originIsArea = false;
				}
			}
			if (field === 'destination') {
				searchCriteria.destinationHandle = null;
				if (scope.allowAreaLocationType === 'true' && angular.isDefined(searchCriteria.destinationIsArea)) {
					searchCriteria.destinationIsArea = false;
				}
			}
			searchValidator.clearValidation(searchCriteria, field);
		};

		function initializeAutoComplete() {
			inputElement.autocomplete({
				autoFocus: !allowAreaLocationType,
				delay: 400,
				source: locationService.suggestions,
				minLength: 3,
				change: function (event, ui) {
					handleItemChanged(ui);
				},
				select: function(event, ui) {
					handleItemChanged(ui);
					event.stopPropagation();
				}
			});
		}

		initializeAutoComplete();

		inputElement.on('blur', function(){
			debugVerbose('blur: isChanged = ' + isChanged);
			debugDumpModel();
			if(!isChanged){
				if (scope.getValidateLocationPromise) {
					$rootScope.$safeApply(function(){
						handleLocationChange(scope.fieldName);
					});
				}
			}
			isChanged = false;
		});

		function debugDumpModel() {
			if (angular.mock && angular.mock.dump)
				debugVerbose('scope.ngModel = ' + angular.mock.dump(scope.ngModel));
		}

		function debugVerbose(str) {
			//$log.debug(str); // uncomment for verbose debugging
		}

		scope.$on('$destroy', function () {
			inputElement.autocomplete('destroy');
		});

		scope.$on('dat:sharedComponents:locationInput:reInit', function () {
			$log.debug('Received dat:sharedComponents:locationInput:reInit');
			inputElement.autocomplete('destroy');
			initializeAutoComplete();
			isChanged = false;
		});
	}
})();
